



































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { JsonServiceClient, toFormData } from '@servicestack/client';
import { redirect, Routes } from '../../shared/router';
import { bus, store, client, getUserInfo } from '../../shared';
import { UserInfo } from '../../shared/user';
import _ from 'lodash';
@Component({
    components: {},
})
export default class Submission extends Vue {
    title = 'Data Study Submission';
    subtitle = 'Your Data Study submission details are as follows.';
    form: any = {
        userId: '',
        rowId: 0,
        firstName: '',
        lastName: '',
        degree: '',
        title: '',
        dataProjectId: '',
        hasORCID: false,
        rsnNoORCID: '',
        orcid: '',
        institution: '',
        email: '',
        phone: '',
        addressline1: '',
        addressline2: '',
        city: '',
        state: '',
        country: '',
        stateOther: '',
        province: '',
        zip: '',
        projectTitle: '',
        projectSummary: '',
        fundingAvailable: false,
        supportType: '',
        supportTypeOther: '',
        grantNumber: '',
        projectEndMonth: '',
        projectEndYear: '',
        cellStimulus: false,
        cellDeath: false,
        type1Diabetes: false,
        tissueEngineering: false,
        alphaCells: false,
        geneticsGenomics: false,
        otherArea: false,
        otherAreaText: '',
        phoneExt: '',
        finalSubmissionDate: '',
        submit: false,
    };
    /* ------------- Data -------------------- */
    /* ------------- Props ------------------- */
    get userInfo() {
        return store.userInfo;
    }
    get userSession() {
        return store.userSession;
    }
    /* ------------- Computed ---------------- */
    /* ------------- Methods ----------------- */
    /* ------------- Lifecycle Hooks --------- */
    async created() {
        if (Object.keys(this.userInfo).length === 0) {
            const u = this.userSession!.userName;
            if (u !== undefined && u !== null) {
                const d = await client.get(new UserInfo({ userName: u }));
                bus.$set(store, 'userInfo', d);
                bus.$emit('userInfo', d);
                if (
                    this.userInfo.data !== undefined &&
                    this.userInfo.data.form !== undefined
                ) {
                    Object.assign(this.form, this.userInfo.data.form);
                }
            }
        }
        if (
            this.userInfo.data !== undefined &&
            this.userInfo.data.form !== undefined
        ) {
            Object.assign(this.form, this.userInfo.data.form);
        }
    }
}
